import { queryClient } from '@/lib/queryClient'
import { useStore } from '@/store'

/**
 * Clears local auth/session state in the browser.
 * This does not call server signout; it only resets client-side state.
 */
export function clearClientAuthSession(): void {
  const store = useStore.getState()
  store.setUser(null)
  store.setShoppingCartId(null)
  queryClient.removeQueries({ queryKey: ['ActiveShoppingCart'], exact: false })
}

export function clearAdminClientAuthSession(): void {
  if (typeof document === 'undefined') {
    return
  }

  const isSecure = window.location.protocol === 'https:'
  const secureFlag = isSecure ? '; secure' : ''
  document.cookie = `admin-jwt=; path=/; sameSite=lax; max-age=0${secureFlag}`
  document.cookie = `admin-session=; path=/; sameSite=lax; max-age=0${secureFlag}`
  document.cookie = `admin-user=; path=/; sameSite=lax; max-age=0${secureFlag}`
}
